import script from "./TileSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TileSelector.vue?vue&type=script&lang=ts&setup=true"

import "./TileSelector.vue?vue&type=style&index=0&id=7c4d79c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4d79c7"]])

export default __exports__